import React, { Component } from 'react';
import styled from 'styled-components';
import { object } from 'prop-types';
import ReactMarkdown from 'react-markdown';
import ProductDetails from './../product-details/ProductDetails';
import ProductImage from './../product-image/ProductImage';
import CheckoutButtonContainer from '../../products/CheckoutButtonContainer';

const CheckoutButton = styled(CheckoutButtonContainer)`
  padding: 8px 12px;
`;

class Product extends Component {
  static propTypes = {
    product: object.isRequired,
  };

  state = {
    showDetails: false,
  }

  handleShowDetails = () => {
    this.setState(prevState => ({ showDetails: !prevState.showDetails }));
  }

  render() {
    const { product } = this.props;
    const {
      advantage, characteristics, recommended, type, fullName,
    } = product;
    const classRecommended = (!recommended) || 'mod-recommend';
    return (
      <section data-e2e="highlight-item" className="box-package">
        <article className={`box-package__main ${classRecommended}`}>
          <ProductImage type={type} positionType="absolute" />
          <div className="box-package__name">
            <p className="box-package__name__text">{fullName}</p>
          </div>
          <div className="box-package__info">
            <div className="box-package__info__text">
              <span>
                <ReactMarkdown source={advantage} />
              </span>
              {!!characteristics.length && <span className="box-package__info__image" onClick={this.handleShowDetails} />}
            </div>
          </div>
          <div className="box-package__buy">
            <CheckoutButton fullWidth type={(recommended) ? 'primary' : 'secondary'} product={product} />
          </div>
        </article>
        <ProductDetails details={characteristics} />
      </section>
    );
  }
}

export default Product;
